export class NewPaypalTransactionModel {
  date: string;
  name: string;
  payment: string;
  gross: string;
  fee: string;
  net: number;
  productName: string;

}
